import { useEffect } from 'react'

const TRACKING_ID = 'AW-16858065180'

export const GoogleAdsTag = () => {
  useEffect(() => {
    const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`

    // Idempotent check: Ensure script is not added more than once
    if (document.querySelector(`script[src="${scriptSrc}"]`)) {
      return
    }

    // Dynamic Script Creation
    const script = document.createElement('script')
    script.src = scriptSrc
    script.async = true

    // Head Insertion
    document.head.appendChild(script)

    // Global Data Structure Initialization
    const w = window as any
    w.dataLayer = w.dataLayer || []

    // Function Definition
    w.gtag = function (...args: any[]) {
      w.dataLayer.push(args)
    }

    // Initialization Commands
    w.gtag('js', new Date())
    w.gtag('config', TRACKING_ID)
  }, [])

  return null
}
